/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const MIN_MAX_ACR = {
    DOOR_HELD_OPEN_DELAY: { start: 4, end: 15 }
}

export const ACR_MODEL = {
    zoneId: null,
    controllerId: null,
    hidSioId: null,
    entryReaderId: null,
    entryOutputId: null,

    enableExitConfig: false,
    exitReaderId: null,
    exitOutputId: null,
    exitInputId: null,
    doorInputId: null,
    doorHeldOpenDelay: null,
    toAddEdit: function () {
        return {
            zoneId: this.zoneId,
            hidSioId: this.hidSioId,
            entryReaderId: this.entryReaderId,
            entryOutputId: this.entryOutputId,
            exitReaderId: this.exitReaderId,
            exitOutputId: this.exitOutputId,
            exitInputId: this.exitInputId,
            doorInputId: this.doorInputId,
            doorHeldOpenDelay: this.doorHeldOpenDelay
        }
    },
    isValid: function () {
        return  this.zoneId !== null &&
        this.hidSioId !== null &&
        this.entryReaderId !== null &&
        this.entryOutputId !== null &&
        this.doorInputId !== null &&
        this.doorHeldOpenDelay !== null &&
        (!this.enableExitConfig || (this.enableExitConfig && this.exitReaderId !== null && this.exitOutputId !== null && this.exitInputId !== null));
    },
    setToTable: function (data, sioName) {
        return {
            id: data.id,
            hidSioId: data.hidSioId,
            hidSioName: sioName,
            zoneName: data.zoneName,
            entryReaderName: data.entryReaderName,
            entryOutputName: data.entryOutputName,
            exitReaderName: data.exitReaderName,
            exitOutputName: data.exitOutputName,
            exitInputName: data.exitInputName,
            doorInputId: data.doorInputId,
            doorInputName: data.doorInputName,
            doorHeldOpenDelay: data.doorHeldOpenDelay
        };
    }
};
